export const SUPPRESSION_TYPES = {
  PERMANENT: 'permanent',
  TEMPORARY: 'temporary',
};

export const SUPPRESSION_REASONS = {
  ACCEPTED_RISK: 'accepted_risk',
  FALSE_POSITIVE: 'false_positive',
  COMPENSATING_CONTROL: 'compensating_control',
  NOT_APPLICABLE: 'not_applicable',
  TEMPORARY_EXCEPTION: 'temporary_exception',
  OTHER: 'other',
};

export const SUPPRESSION_RESTORE_SOURCES = {
  MANUAL: 'manual',
  EXPIRED: 'expired',
  REPLACED: 'replaced',
};

export const SUPPRESSION_ORIGINS = {
  USER: 'user',
  LEGACY_CLIENT: 'legacy_client',
  BACKFILL: 'backfill',
};

/** Must match MAX_TEMPORARY_EXCEPTION_DAYS in cynergy-be. */
export const MAX_TEMPORARY_EXCEPTION_DAYS = 365;
/** Must match the backend DTO limits. */
export const MAX_JUSTIFICATION_LENGTH = 2000;
export const MAX_REASON_OTHER_LENGTH = 200;
/** Temporary exceptions expiring within this many days get the urgent badge. */
export const SUPPRESSION_EXPIRY_WARNING_DAYS = 7;
